import React from 'react';

const EmptyList = () => {
  return (
    <div className="h-96 flex flex-col items-center justify-center my-14">
      <img src="/not-found.png" alt="-" className="mb-8" />
      <h1 className="font-semibold text-3xl mx-2">Maaf, tidak ada data yang ditemukan</h1>
    </div>
  );
};

export default EmptyList;
